import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  addBookmark,
  removeBookmark,
  getBookmarksByContainerContentEntityId,
} from './thunks';
import { BookmarksState } from './types';

export const name = 'bookmarks';

const initialState: BookmarksState = {
  bookmarks: {
    data: [],
    status: 'idle',
  },
  removeBookmarkStatus: 'idle',
};

export const getBookmarksByContainerContentEntityIdAsync = createAsyncThunk(
  name + '/getBookmarksByContainerContentEntityId',
  getBookmarksByContainerContentEntityId
);

export const addBookmarkAsync = createAsyncThunk(
  name + '/addBookmark',
  addBookmark
);

export const removeBookmarkAsync = createAsyncThunk(
  name + '/removeBookmark',
  removeBookmark
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearRemoveBookmark: (state) => {
      state.removeBookmarkStatus = 'idle';
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getBookmarksByContainerContentEntityIdAsync.pending, (state) => {
        state.bookmarks = { data: [], status: 'loading' };
      })
      .addCase(
        getBookmarksByContainerContentEntityIdAsync.fulfilled,
        (state, action) => {
          state.bookmarks = { data: action.payload, status: 'idle' };
        }
      )
      .addCase(
        getBookmarksByContainerContentEntityIdAsync.rejected,
        (state) => {
          state.bookmarks = { data: [], status: 'failed' };
        }
      )
      .addCase(removeBookmarkAsync.pending, (state) => {
        state.removeBookmarkStatus = 'loading';
      })
      .addCase(removeBookmarkAsync.fulfilled, (state) => {
        state.removeBookmarkStatus = 'success';
      })
      .addCase(removeBookmarkAsync.rejected, (state) => {
        state.removeBookmarkStatus = 'failed';
      }),
});

export const actions = slice.actions;

export default slice.reducer;
